import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { TrackingApi } from "@freightsimple/generated-dashboard-openapi-client/apis/TrackingApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useTrackingApi(): TrackingApi {
  const { accessToken } = useAuthentication();
  return new TrackingApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
